import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "../../styles/features/events/GuestEventSignup.css";

export default function GuestEventSignupSuccess() {
  const { eventId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const reservationCode = location.state?.reservationCode;
  const expiresAt = location.state?.expiresAt;
  const email = location.state?.email;
  const eventTitle = location.state?.eventTitle;

  return (
    <div className="guestSignup page">
      <div className="guestSignup__container">
        <h1>Rezerwacja utworzona ✅</h1>
        <p className="muted">
          Wysłaliśmy mail z instrukcją płatności{email ? ` na ${email}` : ""}.
        </p>

        {eventTitle && <p><strong>{eventTitle}</strong></p>}

        {reservationCode && (
          <div className="box">
            <div className="muted">Kod rezerwacji (do płatności):</div>
            <div className="code">{reservationCode}</div>
          </div>
        )}

        {expiresAt && (
          <p className="tiny">
            Termin płatności: <strong>{new Date(expiresAt).toLocaleString()}</strong>
          </p>
        )}

        <div style={{ display: "flex", gap: 10, marginTop: 14 }}>
          <button className="btn" onClick={() => navigate(`/events/${eventId}`)}>
            Wróć do wydarzenia
          </button>
          <button className="btnPrimary" onClick={() => navigate("/")}>
            Strona główna
          </button>
        </div>
      </div>
    </div>
  );
}
